import {Validate} from './validate.js'

export class UserValidate extends Validate {
  _rule = {
    mobile: 'require|phone',
    password: 'require',
    receiver: 'require',
    topic: 'require',
    content: 'require'    
  }
  _message = {
    'mobile.require': '手机号必填',
    'mobile.phone': '手机号码格式不正确',
    'password.require': '密码必填',
    'receiver.require': '请输入收件人ID',
    'topic.require': '请输入站内信信标题',
    'content.require': '请输入站内信内容'
  }
  _scene = {
    login: ['mobile', 'password'],
    sendLetter: ['receiver', 'topic', 'content'],
    editComplain: ['topic', 'content']      
  }
}



// WEBPACK FOOTER //
// ./src/validate/modules/userValidate.js